<template>
  <div class="content_box mt-4">
    <v-tabs
      v-model="selectedTab"
      class="pt-5"
      background-color="white"
      slider-color="var(--app-lighter-primary-color)"
      active-class="tab-active"
    >
      <template v-for="tabButton in tabsButtons">
        <v-tab
          :key="tabButton.href"
          class="tab-padding"
          :href="tabButton.href"
          @click="changeTab(tabButton)"
        >
          {{ tabButton.title }}
          <v-progress-circular
            v-if="isStatisticsLoaded && tabButton.href != '#tab-3'"
            class="ml-0 mr-2"
            color="primary"
            indeterminate
          ></v-progress-circular>
          <v-chip
            v-if="!isStatisticsLoaded && tabButton.href != '#tab-3'"
            class="ml-0 mr-2"
            label
            small
          >
            {{ tabButton.total }}
          </v-chip>
        </v-tab>
      </template>
    </v-tabs>
    <div>
      <div v-if="selectedTab == 'tab-3'">
        <v-col cols="12">
          <naj-alert type="information">
            <template slot="content">
              {{ local.judicialFees.dearCustomer }} {{ local.judicialFees.deceasedSearchAlertInfo }}
            </template>
          </naj-alert>
        </v-col>
        <v-row class="align-center">
          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.number"
              :label="local.judicialFees.filterWithDeceasedSocialId"
              :value.sync="deceasedSocialId"
              :disabled="loading"
            ></naj-input>
            <!-- <naj-search-box
            :type-id="formFieldType.text"
            :placeholder="local.judicialFees.filterWithDeceasedSocialId"
            :search.sync="deceasedSocialId"
            :show-filter="false"
            @filterDataClicked="getDeceasedData()"
          ></naj-search-box> -->
          </v-col>
          <v-col cols="4">
            <naj-button
              :disabled="!deceasedSocialId || loading"
              :loading="loading"
              @click="getDeceasedData()"
            >
              {{ local.common.check }}
            </naj-button>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <naj-search-box
          :type-id="formFieldType.text"
          :placeholder="local.judicialFees.filterWithInvoiceNo"
          :search.sync="searchQuery.invoiceNo"
          @filterDataClicked="filterData()"
          @showFilterClicked="toggleFilter()"
        ></naj-search-box>
      </div>
      <div
        v-if="hasFilter"
        class="filter-row-wrapper d-flex mt-3"
      >
        <div class="col-12">
          <template v-for="filter in filters">
            <span
              v-if="searchQuery[filter.name]"
              :key="filter.name"
              class="ma-1"
            >
              <v-chip
                :key="filter.name"
                :input-value="searchQuery[filter.name]"
                color="#F7FBFB"
                close
                outlined
                @click:close="searchQuery[filter.name]=null ; filterData();"
              >
                <strong class="text-primary">{{ filter.label + ':' + (searchQuery[filter.name+'DisplayName'] || searchQuery[filter.name]) }}</strong>
              </v-chip>
            </span>
          </template>
          <span class="ma-1">
            <v-chip
              color="#F7FBFB"
              outlined
            >
              <strong class="text-primary">{{ local.common.searchResults + ':' + pagination.totalCount }}</strong>
            </v-chip>
          </span>
        </div>
      </div>
      <v-row
        v-if="selectedTab != 'tab-3' || (selectedTab == 'tab-3' && loadedDeceasedBillList )"
        class="mt-7"
      >
        <v-col :cols="showFilter?9:12">
          <naj-item-table
            :data-items="data.list"
            :headers="headers"
            :pagination="pagination"
            :loading="loading"
            :items-per-page="pagination.pageSize"
            :server-items-length="pagination.totalCount"
            :enable-expand="true"
            @update:page="onPageChange"
            @expandSlot="getBillDetails"
          >
            <template
              slot="invoiceNo"
              slot-scope="{item}"
            >
              <div class="info-item-details-title pt-0">
                <div class="d-flex font-weight-black header-text">
                  <div class="pa-3 ml-auto text-c-dark pl-4 pr-0 pb-1  info-item-details-title">
                    {{ local.judicialFees.headers.invoiceNo }}
                  </div>
                  <div class="mt-0">
                    <v-chip
                      color="var(--app-primary-color)"
                      class="br0"
                    >
                      {{ item.providerName }}
                    </v-chip>
                  </div>
                </div>
              </div>
              <div class="info-item-details-value mt-2">
                {{ item.invoiceNo }}
              </div>
            </template>

            <template
              slot="expandButtonText"
              slot-scope="{ }"
            >
              <div class="text-center">
                {{ local.judicialFees.details }}
              </div>
              <div class="text-center">
                {{ local.judicialFees.bill }}
              </div>
            </template>
            <template
              slot="action"
              slot-scope="{item}"
            >
              <div class="mx-4">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-dots-vertical
                    </v-icon>
                  </template>
                  <v-list>
                    <v-list-item>
                      <v-list-item-title>
                        <div>
                          <naj-button
                            text
                            type="button"
                            size="small"
                            @click="showBillTimelineModal(item.objectKey)"
                          >
                            {{ local.judicialFees.billTimeline }}
                          </naj-button>
                        </div>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="!item.objectionRequestCode && item.remainingObjectionDays>0">
                      <v-list-item-title>
                        <div>
                          <naj-button
                            text
                            type="button"
                            size="small"
                            @click="showCreateBillObjectionRequest(item.objectKey, item.providerId)"
                          >
                            {{ local.judicialFees.objectionRequest }}
                          </naj-button>
                        </div>
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-title>
                        <div>
                          <naj-button
                            text
                            type="button"
                            size="small"
                            @click="showInvoiceModal(item.objectKey)"
                          >
                            {{ local.judicialFees.billInvoice }}
                          </naj-button>
                        </div>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </template>

            <template
              slot="expandSlot"
              slot-scope="{ item }"
            >
              <v-row v-if="!item.isLoading">
                <v-col
                  cols="6"
                  class=" mt-3"
                >
                  <div class="header-text font-weight-bold">
                    {{ local.judicialFees.billDetails }}
                  </div>
                  <bill-attributes
                    :attributes="item.attributes"
                    :provider="item.providerId"
                  ></bill-attributes>
                  <div class="header-text font-weight-bold">
                    {{ local.judicialFees.billFeeDetails }}
                  </div>
                  <bill-item-details
                    :item-details="item.itemDetails"
                    :provider="item.providerId"
                  ></bill-item-details>
                  <div
                    v-if="item.isBillUpdated"
                    class="header-text font-weight-bold  pt-3"
                  >
                    {{ (item.billUpdateDetails||{}).actionTypeId == billActionTypeEnum.refundDone ?
                      local.judicialFees.billRefundDetails.title
                      :local.judicialFees.billUpdateDetails.title }}
                  </div>
                  <bill-update-details
                    v-if="item.isBillUpdated"
                    :update-details="item.billUpdateDetails"
                  ></bill-update-details>
                </v-col>
                <v-col
                  cols="6"
                  class="objection-box mt-3"
                >
                  <div class="header-text font-weight-bold">
                    {{ local.judicialFees.billFeeObjection }}
                  </div>

                  <template v-if="!item.objectionRequestCode && item.remainingObjectionDays>0">
                    <naj-alert type="alert">
                      <template slot="content">
                        {{ local.judicialFees.dearCustomer }} {{ local.judicialFees.objectionHeader }}
                      </template>
                    </naj-alert>

                    <div class="d-flex justify-content-center align-items-center pt-8">
                      <naj-button @click="showCreateBillObjectionRequest(item.objectKey, item.providerId)">
                        {{ local.judicialFees.billObjectionRequest }}
                      </naj-button>
                    </div>
                  </template>

                  <template v-if="!item.objectionRequestCode && item.remainingObjectionDays == 0">
                    <naj-alert type="information">
                      <template slot="content">
                        {{ local.judicialFees.dearCustomer }} {{ local.judicialFees.objectionDueDateHeader }}
                      </template>
                    </naj-alert>
                  </template>

                  <template v-if="item.objectionRequestCode">
                    <objection-request-info :bill="item"></objection-request-info>
                  </template>
                </v-col>
              </v-row>
            </template>
          </naj-item-table>
        </v-col>
        <v-col
          v-if="showFilter"
          cols="3"
        >
          <v-card color="pa-3">
            <v-row>
              <v-col class="pt-0">
                <div class="text-left">
                  <v-icon
                    class="icon"
                    @click="toggleFilter()"
                  >
                    mdi-close
                  </v-icon>
                </div>
                <div class="text-h4 font-weight-bold">
                  {{ local.common.filter }}
                </div>
              </v-col>
              <v-col
                v-for="filter in filters"
                :key="filter.name"
                cols="12"
              >
                <naj-input
                  :type-id="filter.typeId"
                  :label="filter.label"
                  :value.sync="searchQuery[filter.name]"
                  :value-name.sync="searchQuery[filter.name+'DisplayName']"
                  :items="filter.items"
                  item-text="name"
                  item-value="id"
                ></naj-input>
              </v-col>

              <v-col
                cols="12"
                class="text-center"
              >
                <naj-button
                  :loading="loading"
                  @click="filterData()"
                >
                  {{ local.common.filter }}
                </naj-button>

                <naj-button
                  outlined
                  @click="toggleFilter()"
                >
                  {{ local.common.close }}
                </naj-button>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <bill-timeline-modal
      ref="billTimelineModal"
      :modal-visibility="selectedBillObjectKey != null"
      :bill-object-key="selectedBillObjectKey"
      @billTimelineModalClose="selectedBillObjectKey=null"
    ></bill-timeline-modal>

    <objection-request-modal
      v-if="selectedBillObjectKeyForObjection!=null"
      ref="objectionRequestModal"
      :modal-visibility="true"
      :bill-object-key="selectedBillObjectKeyForObjection"
      :provider-id="selectedBillProviderIdForObjection"
      @objectionRequestModalClose="objectionRequestModalClose"
    >
    </objection-request-modal>

    <bill-invoice-modal
      ref="billInvoiceModal"
      :modal-visibility="selectedBillInvoicObjectKey != null"
      :bill-object-key="selectedBillInvoicObjectKey"
      @billInvoiceModalClose="selectedBillInvoicObjectKey=null"
    ></bill-invoice-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapJudicialFeesActions, mapState: mapJudicialFeesState } = createNamespacedHelpers('JudicialFeesModule');

import { toHijriDate } from '@/helpers/utils';
import { courtDegrees, billActionType as billActionTypeEnum } from '@/helpers/enum';
import BillTimelineModal from '@/modules/judicialFees/components/bill-timeline-modal.vue';
import BillAttributes from '@/modules/judicialFees/components/bill-attributes.vue';
import BillItemDetails from '@/modules/judicialFees/components/bill-item-details.vue';
import BillUpdateDetails from '@/modules/judicialFees/components/bill-update-details.vue';
import ObjectionRequestModal from '@/modules/judicialFees/components/objection-request-modal.vue';
import ObjectionRequestInfo from '@/modules/judicialFees/components/objection-request-info.vue';
import BillInvoiceModal from '@/modules/judicialFees/components/bill-invoice-modal.vue';
import NajInput from '@/components/shared/naj-input.vue';

export default {
  name: 'JudicialFees',
  components: {
    BillTimelineModal,
    BillAttributes,
    BillItemDetails,
    BillUpdateDetails,
    ObjectionRequestModal,
    ObjectionRequestInfo,
    BillInvoiceModal,
    NajInput,
  },
  data() {
    return {
      toHijriDate,
      selectedTab: null,
      deceasedSocialId: null,
      loadedDeceasedBillList: false,
      isStatisticsLoaded: true,
      selectedBillInvoicObjectKey: null,
      selectedBillProviderIdForObjection: null,
      billActionTypeEnum,
      tabsButtons: [
        {
          href: '#tab-1',
          title: this.local.judicialFees.notPaidBills,
          total: null,
          isPaid: false,
        },
        {
          href: '#tab-2',
          title: this.local.judicialFees.paidBills,
          total: null,
          isPaid: true,
        },
        {
          href: '#tab-3',
          title: this.local.judicialFees.heirsListing,
          total: null,
          isPaid: null,
        },
      ],
      searchQuery: {
        isPaid: false,
        billStatusId: null,
        providerId: null,
        fromDate: null,
        toDate: null,
        invoiceNo: null,
      },
      loading: false,
      showFilter: false,
      data: { list: [] },
      pagination: {
        pageSize: 20,
        pageIndex: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false,
      },
      headers: [
        {
          value: 'invoiceNo',
          class: 'action-item pt-0 pl-0',
          text: this.local.judicialFees.headers.invoiceNo,
          isCustomTemplate: true,
        },
        {
          value: 'amount',
          text: this.local.judicialFees.headers.amount,
          formatter: (val) => { return `${val} ${this.local.judicialFees.sar}`; },
        },
        {
          value: 'creationDate',
          text: this.local.judicialFees.headers.creationDate,
          formatter: toHijriDate,
        },
        {
          value: 'expiryDate',
          text: this.local.judicialFees.headers.expiryDate,
          formatter: (val) => { return this.toHijriDate(val) || '---'; },
        },
        {
          value: 'statusName',
          text: this.local.judicialFees.headers.billStatusName,
        },
        {
          value: 'objectionStatus',
          text: this.local.judicialFees.headers.objectionStatus,
          formatter: (val) => { return val || '---'; },
        },
        {
          value: 'remainingObjectionDays',
          text: this.local.judicialFees.headers.lastObjectionDate,
          formatter: val => `${val} ${this.local.judicialFees.headers.day}`,
        },
        {
          value: 'action',
          class: 'action-item justify-content-center',
          isCustomTemplate: true,
        },
      ],
      degreeButtons: courtDegrees,
      selectedBillObjectKey: null,
      selectedBillObjectKeyForObjection: null,
    };
  },
  computed: {
    ...mapJudicialFeesState(['providers', 'billStatuses']),
    hasFilter() {
      return this.searchQuery.providerId ||
        this.searchQuery.billStatusId ||
        this.searchQuery.toDate ||
        this.searchQuery.fromDate;
    },
    filters() {
      return [
        this.mapFilterItem('providerId', 'provider', 'selectbox', this.providers),
        this.mapFilterItem('billStatusId', 'billStatus', 'selectbox', this.billStatuses),
        this.mapFilterItem('fromDate', 'fromDate', 'date'),
        this.mapFilterItem('toDate', 'toDate', 'date'),
      ];
    },
    computedSearchQuery() {
      return Object.assign({}, this.searchQuery);
    },
  },
  watch: {
    computedSearchQuery: {
      deep: true,
      handler(newValue, oldValue) {
        const oldValueString = JSON.stringify({
          ...oldValue,
          invoiceNo: null,
          isPaid: null,
        });
        const newValueString = JSON.stringify({
          ...newValue,
          invoiceNo: null,
          isPaid: null,
        });
        const isChanged = oldValueString != newValueString;
        if (isChanged) {
          this.filterData();
        }
      },
    },
  },
  mounted() { this.init(); },
  methods: {
    changeTab(tab) {
      if (tab.href != '#tab-3') {
        this.searchQuery.isPaid = tab.isPaid;
        this.filterData();
      }
      else {
        this.data = { list: [] };
        this.pagination = {
          pageSize: 20,
          pageIndex: 0,
          totalCount: 0,
          totalPages: 0,
          hasPreviousPage: false,
          hasNextPage: false,
        };
      }
    },
    mapFilterItem(name, key, typeId, items = []) {
      return {
        name: name,
        label: this.local.judicialFees.filter[key],
        typeId: this.formFieldType[typeId],
        items,
      };
    },
    toggleFilter() {
      this.showFilter = !this.showFilter;
    },
    getBillDetails(bill, index) {
      if (!this.data.list[index].loaded) {
        const objectKey = bill.objectKey;
        this.$set(this.data.list[index], 'isLoading', true);
        Promise.all([
          this.getBillAttributes(objectKey),
          this.getBillItemDetails(objectKey),
          this.getBillUpdateDetails(objectKey),
        ]).then((results) => {
          this.$set(this.data.list[index], 'attributes', results[0].data);
          this.$set(this.data.list[index], 'itemDetails', results[1].data);
          this.$set(this.data.list[index], 'billUpdateDetails', results[2].data);
          this.$set(this.data.list[index], 'isBillUpdated', (results[2].data?.actionTypeId == billActionTypeEnum.refundDone || results[2].data?.actionTypeId == billActionTypeEnum.confirmUpdateInvoice));
          this.$set(this.data.list[index], 'loaded', true);
        })
          .finally(() => {
            this.$set(this.data.list[index], 'isLoading', false);
          });
      }
    },
    showBillTimelineModal(objectKey) {
      this.selectedBillObjectKey = objectKey;
    },
    showInvoiceModal(objectKey) {
      this.selectedBillInvoicObjectKey = objectKey;
    },

    showCreateBillObjectionRequest(billObjectKey, providerId) {
      this.selectedBillObjectKeyForObjection = billObjectKey;
      this.selectedBillProviderIdForObjection = providerId;
      this.$nextTick(() => {
        var modal = this.$refs.objectionRequestModal;
        modal.showModal();
      });
    },
    ...mapJudicialFeesActions(
      [
        'getMyBills',
        'getDeceasedBills',
        'getBillItemDetails',
        'getBillUpdateDetails',
        'getBillAttributes',
        'getProviders',
        'getBillStatuses',
        'getMyBillsStatistics',
      ]
    ),
    init() {
      this.filterData();
      this.getProviders();
      this.getBillStatuses();
      this.isStatisticsLoaded = true;
      this.getMyBillsStatistics().then(({ data }) => {
        if (data) {
          this.tabsButtons[0].total = data.other;
          this.tabsButtons[1].total = data.paid;
        }
      }).finally(() => {
        this.isStatisticsLoaded = false;
      });
    },
    loadData() {
      this.loading = true;
      this.getMyBills({
        ...this.searchQuery,
        ...this.pagination,
      })
        .then(({ data }) => {
          this.data = { ...data };
          this.pagination = {
            pageIndex: data.pageIndex,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            totalPages: data.totalPages,
            hasPreviousPage: data.hasPreviousPage,
            hasNextPage: data.hasNextPage,
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    filterData() {
      this.pagination.pageIndex = 0;
      this.loadData();
    },
    getDeceasedData() {

      this.getDeceasedBills({
        deceasedSocialId: this.deceasedSocialId,
        ...this.pagination,
      })
        .then(({ data }) => {
          this.loadedDeceasedBillList = true;
          this.loading = false;
          this.data = { ...data };
          this.pagination = {
            pageIndex: data.pageIndex,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            totalPages: data.totalPages,
            hasPreviousPage: data.hasPreviousPage,
            hasNextPage: data.hasNextPage,
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onPageChange(pageIndex) {
      this.pagination.pageIndex = pageIndex - 1;
      if (this.selectedTab != 'tab-3')
        this.loadData();
      else
        this.getDeceasedData();
    },
    objectionRequestModalClose() {
      this.selectedBillNumberForObjection = null;
      if (this.selectedTab != 'tab-3')
        this.loadData();
      else
        this.getDeceasedData();
    },

  },
};
</script>

<style lang="scss" scoped>
.tab-padding {
  font-size: 24px;
  padding-bottom: 20px;
  color: var(--app-dark-primary-color) !important;
  .v-chip {
    cursor: pointer;
    color: #ffffff;
    background: var(--app-dark-primary-color) !important;
    border-radius: 0px !important;
  }
}
.tab-active {
  color: var(--app-primary-color) !important;
  font-weight: bold;

  .v-chip {
    background: var(--app-lighter-primary-color) !important;
  }
}

::v-deep .v-tabs {
  .v-tabs-bar {
    .v-tabs-slider-wrapper {
      height: 5px !important;
    }
  }
}

::v-deep .List__empty {
  margin-top: 0px !important;
}

::v-deep .info-item-box .info-item-details:nth-child(2) {
  background: var(--app-light-secondary-color) 0% 0% no-repeat padding-box;
}

::v-deep .action-item {
  justify-content: flex-end;
}

::v-deep .empty {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding: 0 !important;
  .empty-title {
    font-size: 20px;
    line-height: 43px;
    margin: 0;
  }
}

.header-text {
  font-weight: 700;
  font-size: 18px;
  color: var(--app-dark-primary-color);
}
.header-sub-title {
  font-size: 14px;
  font-weight: 700;
}

.br0 {
  border-radius: 0px;
  ::v-deep.v-chip__content {
    color: #fff;
  }
}

.objection-box {
  border-right-color: var(--app-primary-color);
  border-right-style: solid;
  border-right-width: 4px;
}

.search-container {
  border: 2px solid #e5e9f2;
}
.search-box {
  border: 2px solid #e5e9f2;
  ::v-deep .v-input.v-text-field--outlined fieldset {
    border-width: 0 !important;
  }
  ::v-deep .v-input.v-text-field--outlined {
    margin-top: 0 !important;
    .v-input__slot {
      margin-bottom: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }
}

.filter-box {
  justify-content: end;
  cursor: pointer;
  color: var(--app-dark-primary-color);
  font-size: 16px;
  font-weight: bold;
}

.item-title {
  font-size: 14px;
  font-weight: bold;
  color: var(--app-primary-color);
}

.item-value {
  font-weight: bolder;
  font-size: 16px;
  color: var(--app-dark-primary-color);
}

.filter-row-wrapper {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 10px 30px #d1d5df80;
}

::v-deep .v-chip.v-chip--outlined.v-chip.v-chip {
  background-color: #f7fbfb !important;
  border: 1px solid var(--app-primary-color) !important;
  border-radius: unset;

  .v-chip__content {
    button {
      color: var(--app-primary-color);
    }
  }
}
</style>
